import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33f072bd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cont-nav" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Table = _resolveComponent("Table")!
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("section", null, [
      _createElementVNode("nav", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag, i) => {
          return (_openBlock(), _createElementBlock("span", {
            key: 'tag' + i,
            class: _normalizeClass({ active: tag.value === _ctx.activeTagVal }),
            onClick: ($event: any) => (_ctx.checkTag(tag))
          }, _toDisplayString(tag.label), 11, _hoisted_2))
        }), 128))
      ])
    ]),
    _createVNode(_component_a_spin, {
      tip: "加载中...",
      spinning: _ctx.spinning
    }, {
      default: _withCtx(() => [
        ((_ctx.data || []).length)
          ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
              (_openBlock(), _createBlock(_component_Table, {
                key: _ctx.key,
                data: _ctx.data,
                columns: _ctx.columns,
                bordered: true,
                pagination: _ctx.total>10?_ctx.pagination:false
              }, null, 8, ["data", "columns", "pagination"]))
            ]))
          : (_openBlock(), _createElementBlock("section", _hoisted_4, [
              _createVNode(_component_Nodata, {
                nodatadesc: _ctx.activeTagLabel,
                "is-show-s-j": false
              }, null, 8, ["nodatadesc"])
            ]))
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}